<template>
  <b-form-group
    label="Sayfa Alt Başlık"
    label-for="page_subtitle"
  >
    <validation-provider
      #default="{ errors }"
      name="Sayfa Alt Başlık"
      rules="required"
    >
      <b-form-input
        id="page_subtitle"
        v-model="itemData.page_subtitle"
        placeholder="Sayfa Alt Başlık"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormInput } from 'bootstrap-vue'

export default {
  name: 'PageSubTitleText',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['sustainability/dataItem']
    },
  },
}
</script>
